export default function getUrlState() {
	const params = new URLSearchParams(window.location.search);

	const urlStateParam = params.get("state");

	return urlStateParam && JSON.parse(urlStateParam);
}
